import {
  SpeechEndpoint,
  speechSocketUrl,
} from '@euler/components/voice-input/capture/speechEndpoint';

/**
 * The practice's voice socket, on ai-gateway: the trainee's line, its voice
 * parked by the server for it, and each hold handed back to be heard again.
 * The proxies in front of ai-gateway upgrade sockets on /ws only.
 */
export function practiceEndpoint(
  aiEndpoint: string,
  allowWs: boolean,
): SpeechEndpoint {
  return {
    socket: speechSocketUrl(aiEndpoint, '/ws', allowWs),
    frames: 'asr',
    clip: true,
    // A conversation: the trainee talks again soon.
    keepMicrophoneMs: 30_000,
  };
}

const kAttemptId = /^cat_[0-9a-z]{26}$/;

/** A practice hold's start: the attempt the line belongs to. */
export function practiceStart(attemptId: string): Record<string, string> {
  if (!kAttemptId.test(attemptId)) throw new Error('Invalid attempt id');
  return { attemptId };
}
